export enum LoginStatus {
  SUCCESS,
  INVALID_CREDENTIALS,
  INTERNAL_ERROR,
  NEW_USER,
  DISABLED_USER,
  TERMS_OF_USE_ACCEPT_REQUIRED,
  PRIVACY_POLICY_ACCEPT_REQUIRED,
  PASSWORD_CHANGE_REQUIRED,
  EMAIL_CONFIRM,
  OTP_REQUIRED,
  //even if the user has MFA disabled he needs to input a token every 3 months
  // to check if he's still working for the same company
  OTP_REQUIRED_PERIODICALLY,
}

export type LoginResult = {
  status: LoginStatus;
  token?: string;
};
